
import { useState } from "react";
import { TaskFiltersType } from "../../types/tasks";

export const useTaskFilters = () => {
  const [filters, setFilters] = useState<TaskFiltersType>({
    status: "all",
    priority: "all",
    category: "all",
    assignee: "all",
    search: "",
  });

  const [viewMode, setViewMode] = useState<"my" | "all">("my");

  // Filter tasks based on current filters and view mode
  const getFilteredTasks = <T extends { 
    id: string; 
    title: string; 
    status: string;
    priority: string;
    category: string;
    assignee?: { id: string };
  }>(
    tasks: T[],
    userId?: string
  ) => {
    let filteredResults = tasks;
    
    // Filter by view mode (my/all) if user is board member and in "my" view
    if (viewMode === "my" && userId) {
      filteredResults = filteredResults.filter(task => 
        task.assignee && task.assignee.id === userId
      );
    }
    
    // Apply other filters
    return filteredResults.filter((task) => {
      // Filter by search term
      if (filters.search && !task.title.toLowerCase().includes(filters.search.toLowerCase())) {
        return false;
      }
      
      // Filter by status
      if (filters.status !== "all" && task.status !== filters.status) {
        return false;
      }
      
      // Filter by priority
      if (filters.priority !== "all" && task.priority !== filters.priority) {
        return false;
      }
      
      // Filter by category
      if (filters.category !== "all" && task.category !== filters.category) {
        return false;
      }
      
      // Filter by assignee
      if (filters.assignee !== "all") {
        if (filters.assignee === "me" && (!task.assignee || task.assignee.id !== userId)) {
          return false;
        }
        if (filters.assignee === "unassigned" && task.assignee) {
          return false;
        }
      }
      
      return true;
    });
  };

  return {
    filters,
    setFilters,
    viewMode,
    setViewMode,
    getFilteredTasks
  };
};
